const R = require('ramda')

const installPage = require('./page/installClient')
const installData = require('./data/installClient')

module.exports = R.pipe(
  installPage,
  installData,
)
